import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

export type GetWorkshopAccountsFilter = operations['filterWorkshopAccounts']['parameters']['query'];

async function getWorkshopAccountsQuery(apiClient: ApiClient, workshopId: string, filter?: GetWorkshopAccountsFilter) {
  return apiClient.GET(`/op/v2/account/workshop-accounts`, { params: { query: { workshopId, ...filter } } });
}

export default function useWorkshopAccountsQuery(workshopId: string, filter?: GetWorkshopAccountsFilter, enabled = true) {
  const toast = useToast();
  const apiClient = useApiClient();

  const query = useQuery<InferFetchData<typeof getWorkshopAccountsQuery>, ApiError>({
    queryKey: getKey(workshopId, filter),
    queryFn: () => throwOnError(getWorkshopAccountsQuery(apiClient, workshopId, filter)),
    enabled,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(workshopId: string, filter?: GetWorkshopAccountsFilter): QueryKey {
  return ['WorkshopAccountsQuery', workshopId, filter] as const satisfies QueryKey;
}

useWorkshopAccountsQuery.getKey = getKey;
